(() => {
  const hubs = document.querySelectorAll('[data-av55-protein-hub]');

  hubs.forEach((hub) => {
    const form = hub.querySelector('[data-av55-protein-selector]');
    const cards = Array.from(hub.querySelectorAll('[data-av55-protein-result]'));
    const empty = hub.querySelector('[data-av55-protein-empty]');
    const status = hub.querySelector('[data-av55-protein-status]');

    if (!form || cards.length === 0) return;

    const selectedValue = (suffix) => {
      const input = form.querySelector(`input[name$="${suffix}"]:checked`);
      return input ? input.value : 'all';
    };

    const update = () => {
      const moment = selectedValue('-moment');
      const format = selectedValue('-format');
      let visible = 0;

      cards.forEach((card) => {
        const matchesMoment = moment === 'all' || card.dataset.moment === moment;
        const matchesFormat = format === 'all' || card.dataset.format === format;
        const show = matchesMoment && matchesFormat;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible > 0;
      if (status) {
        status.textContent = visible === 1
          ? '1 formato encontrado.'
          : `${visible} formatos encontrados.`;
      }
    };

    form.addEventListener('change', update);
    form.addEventListener('reset', () => window.requestAnimationFrame(update));
    update();
  });
})();
(() => {
  if (window.__avProteinRouteV100) return;
  window.__avProteinRouteV100 = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seenViews = new Set();
  let lastCartSignal = '';

  const emit = (eventName, payload = {}) => {
    if (!eventName || window.AVAnalytics?.consentAllowed?.() !== true) return false;
    const detail = {
      event: eventName,
      component: 'protein-route',
      ...payload,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('av:analytics', { detail }));
    document.dispatchEvent(new CustomEvent('av:trace:analytics', { detail }));
    return true;
  };

  const markVisible = (element) => {
    element.classList.add('is-protein-visible');
  };

  const observeOnce = (elements, callback) => {
    const list = Array.from(elements).filter((element) => !element.dataset.avProteinObserved);
    if (!list.length) return;
    list.forEach((element) => { element.dataset.avProteinObserved = 'true'; });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      list.forEach((element) => {
        markVisible(element);
        if (callback) callback(element);
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        markVisible(entry.target);
        if (callback) callback(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.16 });

    list.forEach((element) => observer.observe(element));
  };

  const initMoments = (scope) => {
    scope.querySelectorAll('[data-av-protein-moments]').forEach((root) => {
      if (root.dataset.avProteinMomentsReady) return;
      root.dataset.avProteinMomentsReady = 'true';
      const buttons = Array.from(root.querySelectorAll('[data-av-protein-moment-select]'));
      const panels = Array.from(root.querySelectorAll('[data-av-protein-moment-panel]'));
      if (!buttons.length || !panels.length) return;

      const selectMoment = (button, shouldTrack = true) => {
        const moment = button.dataset.avProteinMomentSelect;
        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.avProteinMomentPanel === moment;
          panel.classList.toggle('is-selected', selected);
          panel.toggleAttribute('hidden', !selected);
        });
        if (shouldTrack) emit('av_protein_moment_select', { selected_moment: moment });
      };

      buttons.forEach((button) => button.addEventListener('click', () => selectMoment(button)));
      selectMoment(buttons.find((button) => button.getAttribute('aria-pressed') === 'true') || buttons[0], false);
    });
  };

  const trackClick = (event) => {
    const tracked = event.target.closest('[data-av-protein-track]');
    if (tracked) {
      const payload = {
        source_section: tracked.dataset.sourceSection || '',
        destination: tracked.dataset.destination || '',
        selected_format: tracked.dataset.selectedFormat || '',
        product_id: tracked.dataset.productId || '',
        product_handle: tracked.dataset.productHandle || '',
      };
      emit(tracked.dataset.avProteinTrack, payload);
    }

    const featured = event.target.closest('[data-av-protein-featured-product]');
    if (featured) {
      emit('av_protein_featured_product_click', {
        product_id: featured.dataset.productId || '',
        product_handle: featured.dataset.productHandle || '',
        format_family: featured.dataset.formatFamily || '',
        item_position: featured.dataset.itemPosition || '',
      });
    }

    const sizeChoice = event.target.closest('[data-av-protein-size-choice]');
    if (sizeChoice) {
      emit('av_protein_max_slim_choice', {
        size_choice: sizeChoice.dataset.avProteinSizeChoice,
        product_id: sizeChoice.dataset.productId || '',
        product_handle: sizeChoice.dataset.productHandle || '',
      });
    }

    const comparison = event.target.closest('.avc14-comparison-card a');
    if (comparison && comparison.closest('[data-av-protein-hub-page]')) {
      const card = comparison.closest('[data-av-product-handle]');
      emit('av_protein_comparison_click', {
        product_handle: card ? card.dataset.avProductHandle || '' : '',
      });
    }
  };

  const init = (scope = document) => {
    document.documentElement.dataset.avProteinEnhanced = 'true';
    const hub = document.querySelector('[data-av-protein-hub]');
    if (hub) document.documentElement.dataset.avProteinHubPage = 'true';

    observeOnce(scope.querySelectorAll('.avp100'), (section) => {
      const sectionName = section.dataset.avProteinSection || '';
      const viewKey = `${sectionName}:${section.id}`;
      if (sectionName === 'hero' && !seenViews.has(viewKey)) {
        if (emit('av_protein_hub_view', { section_id: section.id })) seenViews.add(viewKey);
      }
    });
    observeOnce(scope.querySelectorAll('[data-av-protein-reveal]'));
    observeOnce(scope.querySelectorAll('[data-av-protein-destination]'), (destination) => {
      const key = `destination:${destination.dataset.avProteinDestination}`;
      if (seenViews.has(key)) return;
      if (emit('av_protein_destination_view', {
        destination: destination.dataset.avProteinDestination,
        action: 'view',
      })) seenViews.add(key);
    });
    initMoments(scope);
  };

  const productIsInHub = (productId) => {
    if (!productId) return false;
    return Boolean(document.querySelector(`.avp100 [data-product-id="${CSS.escape(String(productId))}"]`));
  };

  const handleCartSignal = (event) => {
    const detail = event.detail || {};
    const productId = detail.product_id || detail.productId || (detail.product && detail.product.id) || '';
    const variantId = detail.variant_id || detail.variantId || (detail.variant && detail.variant.id) || '';
    if (!productIsInHub(productId)) return;
    const signal = `${productId}:${variantId}:${Math.floor(Date.now() / 800)}`;
    if (signal === lastCartSignal) return;
    lastCartSignal = signal;
    emit('av_protein_hub_add_to_cart', { product_id: productId, variant_id: variantId });
  };

  document.addEventListener('click', trackClick);
  ['av:cart:add', 'av:cart:added', 'av:cart:add-success'].forEach((name) => document.addEventListener(name, handleCartSignal));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('visitorConsentCollected', () => {
    document.querySelectorAll('.avp100, [data-av-protein-destination]').forEach((element) => delete element.dataset.avProteinObserved);
    init(document);
  });
  document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  if (document.readyState !== 'loading') init(document);
})();

